module.exports = __webpack_public_path__ + "media/guest.e537f59f.wav";